import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

export const MESSAGE_SENDER = {
  USER: 'user',
  BOT: 'bot'
}

export const MESSAGES_TYPES = {
  TEXT: 'text',
  CAROUSEL: 'carousel',
  CUSTOM_COMPONENT: 'component',
}

export const PROP_TYPES = {
  MESSAGE: ImmutablePropTypes.contains({
    type: PropTypes.oneOf([
      MESSAGES_TYPES.TEXT,
    ]),
    text: PropTypes.string,
    sender: PropTypes.oneOf([
      MESSAGE_SENDER.USER,
      MESSAGE_SENDER.BOT
    ])
  }),

  CAROUSEL: ImmutablePropTypes.contains({
    type: PropTypes.oneOf([
      MESSAGES_TYPES.CAROUSEL
    ]),
    slides: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      image: PropTypes.string,
      image_link: PropTypes.string,
      buttons: PropTypes.arrayOf(PropTypes.shape({
        text: PropTypes.string,
        value: PropTypes.string,
        type: PropTypes.string,
      }))
    })),
    sender: PropTypes.oneOf([
      MESSAGE_SENDER.USER,
      MESSAGE_SENDER.BOT
    ])
  })

}



// WEBPACK FOOTER //
// ./src/ChatWidget/constants.js